import React, { Component } from 'react'

import ContactCardItem from './ContactCardItem'
import CardListHeader from '../../common/list/v1/CardListHeader'
import _ from 'lib/lodash'

import './ContactCardList.css'

class ContactCardList extends Component {
	render() {
		const { actionHandler, nodes, aclAllow, title } = this.props;

		// reverse nodes to have newest on top
		const renderCards = () => _.map(nodes, (node, key) => (
			<ContactCardItem node={node} key={key} actionHandler={actionHandler} aclAllow={aclAllow}/>)
		);

		return (
			<section className="md-grid md-grid--no-spacing contact-card-list">
				<CardListHeader
					nodes={nodes}
					actionHandler={actionHandler}
					title={title}
					titleOne="Kontakt"
					titleMany="Kontakte"
					aclAllow={aclAllow}
				/>
				<div className="contact-card-list-items">
					{renderCards()}
				</div>
			</section>
		);

	}
}

export default ContactCardList;




// WEBPACK FOOTER //
// ./src/components/cards/contact/v1/ContactCardList.jsx